import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropertySearch from "../components/PropertySearch";
import CTA from "../components/cta";
const PAGE_SIZE = 8;

const PropertyForSale = ({ typ = "Sale" }) => {
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";
  const [listings, setListings] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [sortBy, setSortBy] = useState("id DESC");
  const [filters, setFilters] = useState({}); // current search filters

  const shown = listings?.length || 0;

  // -------------------------------
  // FETCH LISTINGS
  // -------------------------------
  const fetchListings = async (pageNo = 1, isLoadMore = false, currentFilters = {}) => {
    setLoading(true);
    try {
     const propertyCategory = currentFilters.property_category?.trim();
     const body = {
  typ,
  page: pageNo,
  pageSize: PAGE_SIZE,
  sortBy,
  offering_type: currentFilters.offering_type || typ,
  ...(propertyCategory ? { property_category: propertyCategory } : {}),
  city: currentFilters.city || "",
  property_type: currentFilters.property_type || "",
  bedrooms: currentFilters.bedrooms || "",
  bathrooms: currentFilters.bathrooms || "",
  minPrice: currentFilters.minPrice || "",
  maxPrice: currentFilters.maxPrice || "",
  minArea: currentFilters.minArea || "",
  maxArea: currentFilters.maxArea || "",
};


      const res = await fetch(`${API}/api/propertysearch.ashx`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const result = await res.json();

      if (result.result === 1) {
        setTotal(result.total || 0);
        setListings(prev => (isLoadMore ? [...prev, ...(result.data || [])] : (result.data || [])));
        setHasMore(pageNo * PAGE_SIZE < (result.total || 0));
      }
    } catch (err) {
      console.error("Error fetching listings:", err);
    } finally {
      setLoading(false);
    }
  };

  // -------------------------------
  // SEARCH HANDLER
  // -------------------------------
  const handleSearch = (newFilters) => {
    setFilters(newFilters);
    setListings([]);
    setPage(1);
    setHasMore(true);
    fetchListings(1, false, newFilters); // fetch with filters
  };

  // -------------------------------
  // LOAD MORE HANDLER
  // -------------------------------
  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchListings(nextPage, true, filters);
  };

  // -------------------------------
  // FETCH ON PAGE LOAD OR SORT CHANGE
  // -------------------------------
  useEffect(() => {
    fetchListings(1, false, filters);
  }, [typ, sortBy]);

  // -------------------------------
  // RENDER
  // -------------------------------
  return (
    <>
       <section
    className="flat-title-page mrg-0 boder-r-0"
    style={{
      backgroundImage:
        "url(images/img/sale-banner.jpg)"
    }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Properties for Sale</h1>
         <div className="container">
        <section
          className="flat-filter-search-v2 flat-section flat-recommended pt-0"
          style={{ marginTop: 2 }}
        > 
          <PropertySearch onSearch={handleSearch} /> 
        </section>
      </div>
      </div>
    </div>
  </section>  
      <div className="container">
        <section className="flat-section flat-recommended pt-0">
          <div className="container">
            {/* TITLE + SORT */}
            <div className="box-title-listing">
              <div className="box-left">
                <h3 className="title fw-8">
                  {(filters.property_category || "All")} Properties for{" "}
                  {(filters.offering_type || typ) === "Sale" ? "Sale" : "Rent"}
                  {filters.city ? ` in ${filters.city}` : ""}
                </h3>
                <p>
                  Showing {shown} properties out of {total}
                </p>
              </div>

              <div className="box-filter-tab">
                <select
                  className="nice-select select-filter list-sort"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                > 
                  <option value="id DESC">Newest</option>
                  <option value="id asc">Oldest</option>
                  <option value="price asc">Price: Low → High</option>
                  <option value="price DESC">Price: High → Low</option>
                </select>
              </div>
            </div>

            {/* LISTINGS GRID */}
            <div className="row">
              {loading && (
                <div className="row">
                  {Array.from({ length: 8 }).map((_, i) => (
                    <div className="col-xl-3 col-lg-6 col-md-6" key={i}>
                      <div className="homelengo-box skeleton">
                        <div className="skeleton-img" />
                        <div className="skeleton-body">
 <div className="skeleton-line w-80" />
 <div className="skeleton-line w-60" />
 <div className="skeleton-line w-40" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {listings?.map((item) => (
                <div className="col-xl-3 col-lg-6 col-md-6" key={item.id}>
                  <div className="homelengo-box">
                    <div className="archive-top">
                      <Link className="images-group" to={`/property/${item.url || ""}/${item.id}`}>
                        <div className="images-style">
 <img src={item.ImagePath+"/w=365,sharpen=1"} alt={item.title} className="lazyloaded" />
                        </div>
                        <div className="top">
 <ul className="d-flex gap-6">
   <li className="flag-tag primary">{item.property_type}</li>
   <li className="flag-tag style-1">For {item.offering_type}</li>
 </ul>
                        </div>
                      </Link>
                    </div>

                    <div className="archive-bottom">
                      <div className="content-top">
                        <h6 className="text-capitalize">
 <Link className="link" to={`/property/${item.url || ""}/${item.id}`}>
   {item.title}
 </Link>
                        </h6>
                        <p>{item.sub_community}, {item.community}, {item.city}</p>
                            <ul className="meta-list">
                     {item.rsco === "Residential" && (
    <>
      <li className="item">
        <i className="fa-solid fa-bed" />{" "}
        <strong>
          {Number(item.bedrooms) === 0 ? "Studio" : item.bedrooms}
        </strong>
      </li>

      <li className="item">
        <i className="fa-solid fa-bath" />{" "}
        <strong>{item.No_of_Bathroom}</strong>
      </li>
        <li className="item">
      <i className="fa-solid fa-ruler-combined" />{" "}
      <strong>{Number(item.size).toLocaleString()} SQFT</strong>
    </li>
    </>
  )}

  {item.rsco === "Commercial" && (
    <li className="item">
      <i className="fa-solid fa-ruler-combined" />{" "}
      <strong>{Number(item.size).toLocaleString()} SQFT</strong>
    </li>
  )}
                        </ul>
                        <p className="pt-10">Property ID: {item.reference_number}</p>
                   
                      </div>

                      <div className="content-bottom">
                        <h6 className="price">AED {Number(item.price).toLocaleString()}</h6>
                      </div>
                 <div className="listing-card">
                 <img src={item.agent_img+"/w=60,sharpen=1"} alt="Agent" className="agent-img" />
                 <div className="text-content">
                 <div className="listing-by">Listing by</div>
                 <div className="agent-name">{item.agent_name}</div>
                 </div>
               </div>
               <div className="content-bottom1">
              <div className="property-icns-w">
                <Link to={`tel:${item.agent_phone}`}>
                  <i className="icon">
                    <img src="images/img/phone.svg" alt="Call" />
                  </i>
                  Call
                </Link>
                <Link
                  to={`https://web.whatsapp.com/send?phone=${item.agent_whatsapp}&text=Hi, I am interested in the listing, ${item.title}, from your website.`}
                  target="_blank"
                >
                  <i className="icon">
                    <img src="images/img/whatsapp.svg" alt="Whatsapp" />
                  </i>
                  Whatsapp
                </Link>
              </div>
               </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* LOAD MORE BUTTON */}
            {hasMore && (
              <div className="text-center mt-4">
                <button className="tf-btn-full btn-line" onClick={handleLoadMore} disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Loading...
                    </>
                  ) : (
                    "Load More"
                  )}
                </button>
              </div>
            )}
          </div>
        </section>
      </div>
      <CTA/>
    </>
  );
};

export default PropertyForSale;
